import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconDownload, IconX } from '@tabler/icons';
import { useEffect, useState } from 'react';
import PdfPreview from '../../Molecules/Document/PdfPreviewNew';
import { FileS } from '../../Service/FileS';

const EmailFileAttachment = ({ downloadable = false, attachment, eventId, index, deleteAtIndex }) => {
  const [fileExists, setFileExists] = useState(true);
  const { entityId, entityType, fileName } = attachment;

  useEffect(() => {
    if (entityType === 'profiles') {
      FileS.isFileExists(entityType, entityId, fileName).then(setFileExists);
    }
  }, [entityType, entityId, fileName]);

  return (
    <Tooltip
      withArrow
      color="red"
      disabled={fileExists}
      label="Datei nicht gefunden"
      position="right"
      transition="slide-right"
    >
      <Group
        p="xs"
        sx={(theme) => ({
          borderRadius: theme.radius.sm,
          backgroundColor: fileExists
            ? theme.colorScheme === 'dark'
              ? theme.colors.dark[5]
              : theme.colors.gray[0]
            : 'red',
        })}
      >
        <PdfPreview eventId={eventId} file={attachment} fileExists={fileExists} />
        {downloadable && fileExists && (
          <ActionIcon size="xs">
            <IconDownload onClick={() => FileS.downloadFile(entityType, entityId, fileName)} />
          </ActionIcon>
        )}
        {deleteAtIndex && (
          <ActionIcon size="xs">
            <IconX onClick={() => deleteAtIndex(index)} />
          </ActionIcon>
        )}
      </Group>
    </Tooltip>
  );
};

export default EmailFileAttachment;
